@if(loading){ }@else{
<div class="main-container">
  @if (title ===null || title ==='') {
  <div class="approve-container">
    <mat-icon svgIcon="ic-check-on"></mat-icon>
    @if (pay === 'true') {
    <p class="as-font as-font-24">{{ 'PAYPAL.completed' | translate }}</p>
    } @else{

    <p class="as-font as-font-24">{{ 'PAYPAL.completedMethod' | translate }}</p>
    }
  </div>
  } @else{
  <div class="as-modal-paypal-container">
    <div class="as-title-wrapper">
      <h2 class="as-title">{{ title || 'Error inesperado' }}</h2>
    </div>
    <div class="as-body-wrapper">
      <mat-icon svgIcon="ic-card-error"></mat-icon>
      <p class="as-body">
        {{
          subtitle ||
            'Por favor, intenta de nuevo en unos minutos o utiliza otro método de pago.'
        }}
      </p>
      <p class="as-hint">
        {{ micro_copy || 'Si el problema persiste, contacta a soporte.' }}
      </p>
    </div>
    <button mat-flat-button color="accent" (click)="notifyMobile('false')">
      <mat-label class="as-font as-font-white as-font-semibold">
        Entendido
      </mat-label>
    </button>
  </div>
  }
</div>
}
